import { Button } from "risa-oasis-ui_v2";
import BadgeDropdown from "../../../../components/badgeDropdown/badgeDropdown";
import { useAuthStatusDropdown } from "../../../../hooks/useAuthStatusDropdown";
import WarningIcon from "../../../../svg/warningIcon";

interface RpaErrorProps {
  onRetry: () => void;
}

const RpaError = (props: RpaErrorProps) => {
  const { selectedAuthStatusBadge, handleAuthStatusChange, authStatusOptions } =
    useAuthStatusDropdown();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <div className="flex flex-col items-center justify-center gap-2">
        <WarningIcon />
        <div className="flex flex-row items-center justify-center gap-4">
          <div className="text-center">
            There was an error with the RPA.
            <br />
            Please try again.
          </div>
        </div>
      </div>
      <Button
        buttonType="primary"
        size="medium"
        disabled={false}
        onClick={props.onRetry}
      >
        Retry
      </Button>
      <div className="flex items-center gap-2">
        <div className="text-sm font-normal text-primaryGray-1">
          Select Auth Status
        </div>
        <BadgeDropdown
          selectedBadge={selectedAuthStatusBadge}
          badgeList={authStatusOptions}
          onClick={handleAuthStatusChange}
        />
      </div>
    </div>
  );
};

export default RpaError;
